// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__QZjDv","row":"Node_row__2g8-w","label":"Node_label__1EKaj","footer":"Node_footer__3I_dk"};